import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import PromotorsController from './promotors.controller';
import { Layout, TableSkeleton, AnalyticsSkeleton, PageHeader } from '../common';
import { PromoterTable, TableActions, PromoterAnalytics } from './elements';
import withNavigate from '../../core/withNavigate';
import { Button } from 'antd';
import { Users, ChartColumn } from 'lucide-react';
import { t } from '../../company/labels';

class ShelfPromoters extends Inherit(PromotorsController, Component) {
    state = {
        promoters: [],
        loading: true,
        rows: [],
        clientOptions: [],
        selectedClientId: null
    };

    render() {
        const { promoters, loading, rows, clientOptions, selectedClientId } = this.state;
        const isClientUser = this.isClientUser();

        return (
            <Layout current="promoters">
                <PageHeader
                    icon={<Users />}
                    title={t('promotores')}
                    description={`Gestiona el equipo de ${t('promotoresLower')} y su desempeño`}
                    actions={
                        // Analytics are hidden for client users
                        !isClientUser && (
                            <Button type="primary" icon={<ChartColumn />} onClick={this.navigateToAnalytics.bind(this)}>
                                Ver Analíticas
                            </Button>
                        )
                    }
                />

                {loading ? (
                    <div className="space-y-4">
                        <AnalyticsSkeleton count={4} />
                        <TableSkeleton rows={10} columns={6} />
                    </div>
                ) : (
                    <div className="space-y-4">
                        <PromoterAnalytics promoters={promoters} />

                        <TableActions
                            promoters={promoters}
                            setRows={this.setRows.bind(this)}
                            clientOptions={clientOptions}
                            selectedClientId={selectedClientId}
                            onClientChange={this.selectClient.bind(this)}
                        />
                        <PromoterTable
                            promoters={rows}
                            loading={loading}
                            removePromoter={this.removePromoter.bind(this)}
                            navigatePromoter={this.navigatePromoter.bind(this)}
                        />
                    </div>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfPromoters);
